import { hex, score } from 'wcag-contrast';

import { Currency } from '../weborder/Api';

const colorContrast = (hex1: string, hex2: string): boolean => {
  const contrastScore = hex(hex1, hex2);
  const result = score(contrastScore);

  const hasAccessibleColourContrast = ['AA', 'AAA'].includes(result);
  return hasAccessibleColourContrast;
};

const hasLocationServicePermission = (): boolean => {
  const { userAgent } = navigator;
  const isAndroid = /Android/i.test(userAgent);
  const isFirefox = /firefox/i.test(userAgent);
  const isChrome = (window as any).chrome;

  if (!navigator.geolocation) {
    return false;
  }

  if (isChrome || isFirefox || isAndroid) {
    return (window as any).isSecureContext;
  }

  return window.location.protocol === 'https:';
};

const isDecimalCurrency = (currency: Currency): boolean => {
  const nonDecimalCurrencies = [
    Currency.CLP,
    Currency.DJF,
    Currency.JPY,
    Currency.KRW,
    Currency.PYG,
    Currency.RWF,
    Currency.VND,
    Currency.XAF,
    Currency.XOF,
  ];

  return !nonDecimalCurrencies.includes(currency);
};

const isElixirHosted = (): boolean => {
  const htmlTag = document.querySelector('html');
  return htmlTag.getAttribute('id') === 'elixir';
};

const isValidEmail = (email: string): boolean => {
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const checkUtils = {
  colorContrast,
  hasLocationServicePermission,
  isDecimalCurrency,
  isElixirHosted,
  isValidEmail,
};
